import { useMemo } from 'react';
import { Col, Container, Row } from 'reactstrap';
import StudentWarningsSummaryDetailsBlock from '../StudentWarningsSummaryDetailsBlock';
import { useStudentsRiskHistoryDetails } from './loaders/StudentsRiskHistoryDetailsLoader';
import { StudentsRiskHistoryDetailsOrigin } from './types';

type StudentsRiskHistoryDetailsBoxesProps = {
  origin?: StudentsRiskHistoryDetailsOrigin;
};

const StudentsRiskHistoryDetailsBoxes = ({
  origin = 'riskSession',
}: StudentsRiskHistoryDetailsBoxesProps) => {
  const { result } = useStudentsRiskHistoryDetails();

  const items = useMemo(() => {
    if (!result?.success || !result?.data) {
      return [];
    }

    return result?.data?.data?.riskGroups || [];
  }, [result]);

  const columnSize = useMemo(() => {
    switch (items.length) {
      case 5:
        return 2;
      case 4:
        return 3;
      case 3:
        return 4;
      case 2:
        return 6;
      default:
        return 12;
    }
  }, [items]);

  const remainingSize = useMemo(() => {
    return Math.max(0, 12 - items.length * columnSize);
  }, [items, columnSize]);

  if (!result?.success || !result?.data) {
    return <></>;
  }

  if (origin === 'studentFile' && items.length === 0) {
    return <></>;
  }

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        {items?.map((item, i) => (
          <Col
            xs={12}
            md={columnSize + (i === items.length - 1 ? remainingSize : 0)}
            className="pt-3"
            key={i.toString()}
          >
            <StudentWarningsSummaryDetailsBlock {...item} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default StudentsRiskHistoryDetailsBoxes;
